<div class="selection-header" *ngIf="selectedMode">
  <div class="left">
    <button class="close-btn" (click)="clearSelection()">✕</button>
    <span>{{ selectedCount }} selected</span>
  </div>
  <div>
  <img alt="trash" class="trash-icon" src="./assets/images/trash.svg"/>
  <button class="delete-btn" (click)="openDeleteOptions()">Delete</button>
  </div>
  
</div>

<div class="chat-history" (scroll)="onScroll($event)"> 
  <div *ngIf="groupedMessages?.length === 0 && searchText" class="no-matches">
    No data found.
  </div>

  <ng-container *ngFor="let message of groupedMessages">
    <div *ngIf="message?.isHeader" class="date-header">
      <span>{{ message?.date }}</span>
    </div>

    <div *ngIf="!message?.isHeader" class="message-container" #chatHeightCal  [class.selected-msg-bg]="message.isSelected"> 
      <!-- From Pharmacist -->
      <div *ngIf="message?.sender?.identifierType === 1" class="spc-from-pharmacist">
        <div class="spc-your-pharmacist">{{ (message?.sender?.userName) ? message?.sender?.userName : pharmacyName }}</div>
        <div class="spc-pharmacist-msg">
          <span [innerHTML]="parseMessage(message.message)"></span> 
        </div>
        <div class="spc-recieved-date-time">{{ message?.date | date:'h:mm a' }}</div>
      </div>

      <!-- You -->
      <div *ngIf="message?.sender?.identifierType === 3" class="spc-frm-you">
        <div class="spc-frm-msg">
          <div *ngIf="isDeletedMessages(message.message)">
          <div [innerHTML]="message.message"></div>
          </div>
          <span *ngIf="!isDeletedMessages(message.message) && parseMessageForPatient(message.message)"
      [innerHTML]="parseMessageForPatient(message.message)">
    </span>
          <div class="spc-images" *ngIf="getUrls(message?.message).length">
         <img 
  *ngFor="let u of getUrls(message?.message)" 
  [src]="u"
  class="chat-img" (contextmenu)="$event.preventDefault()"
   (error)="hideFailedImage(message, u)"
   [class.hidden-img]="message.failedImages?.has(u)"
  (mousedown)="onPressStart(message, $event)"
  (mouseup)="onPressEnd($event)"
  (touchstart)="onPressStart(message, $event)"
  (touchend)="onPressEnd($event)"
  (click)="onImageClick(u, message, $event)"
  [class.selected-img]="message.isSelected"
/>

          </div>
        </div>

        <div *ngIf="isDeletedMessages(message.message)" class="spc-sent-date-time">
          {{ message?.date | date:'h:mm a' }}
          <svg
            class="tick-icon"
            width="14"
            height="15"
            viewBox="0 0 14 15"
            [attr.fill]="message?.isRead ? '#019F08' : '#9094A0'" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.90838 10.788L0.612549 7.49219L1.4438 6.67552L3.92297 9.15469L4.73963 9.97135L3.90838 10.788ZM7.20422 10.788L3.90838 7.49219L4.72505 6.66094L7.20422 9.1401L12.5709 3.77344L13.3875 4.60469L7.20422 10.788ZM7.20422 7.49219L6.37297 6.67552L9.26047 3.78802L10.0917 4.60469L7.20422 7.49219Z"
            />
          </svg>
        </div>
      </div>
    </div> 
  </ng-container>   
</div>

<div class="spc-lightbox" *ngIf="isHistoryPreviewOpen" (click)="closeHistoryPreview()">
  <div class="spc-lightbox__content" (click)="$event.stopPropagation()">
    <button class="spc-lightbox__close" type="button" aria-label="Close" (click)="closeHistoryPreview()">×</button>
    <img [src]="historyPreviewUrl" alt="Full preview" class="spc-lightbox__image" />
  </div>
</div>
<div class="delete-overlay" *ngIf="showDeleteOptions" (click)="closeDeleteOptions()"></div>
<div class="delete-popup" *ngIf="showDeleteOptions" (click)="$event.stopPropagation()">
  <button class="popup-close" (click)="closeDeleteOptions()">✕</button>
  <div class="popup-title">Delete message?</div>
   <div class="popup-option red" (click)="deleteImage(false)">Delete for everyone</div>
  <div class="popup-option" (click)="deleteImage(true)">Delete for me</div>
 </div>
